// Words inside the shared calculator form card of the Hindi daily hub's
// "which rashi is yours?" check (/hi/aaj-ka-rashifal/, RashifalHubCheck), and
// the controls of its answer: the submit, the no-time explainer, the check's
// errors, the answer's two buttons and its one link. Until 2026-10-25 the 12
// /hi/rashifal/<sign>/ pages' check used them too; those pages merged into the
// hub. Hindi controls are Devanagari Hindi, like the card's labels in
// BirthDetailsForm.i18n.ts (owner decision 2026-10-28, replacing the
// 2026-10-08 Hinglish rule; tests/hindi-register.test.ts guards this file).
// The section heading, its lead and the answer's text are page copy in their
// components (RashifalHubCheckSection.tsx, RashifalHubAnswerHi.tsx).
export const RASHIFAL_CHECK_HI_COPY = {
  submit: "अपनी राशि जाँचें",
  // The English check's explainer (RASHI_TIME_UNKNOWN_EXPLAINER): what this
  // check does without a time, from the engine's day windows.
  timeUnknownExplainer:
    "कोई बात नहीं: जाँच आपकी जन्म तिथि और जन्म स्थान से होती है। अगर उस दिन चंद्रमा एक ही राशि में रहा, तो तिथि से ही राशि तय हो जाती है। अगर उस दिन राशि बदली, तो बदलाव का समय और उसके दोनों तरफ़ की राशि दिखेगी।",
  unavailable: "गणना नहीं हो पाई — कृपया दोबारा कोशिश करें।",
  unreadable: "यह नतीजा पढ़ा नहीं जा सका। कृपया दोबारा कोशिश करें।",
  checkAnother: "दूसरी जन्म तिथि जाँचें",
  addTime: "जन्म समय डालें",
} as const;

/** The answer's one link: "आज का सिंह राशिफल पढ़ें", the sign in its Hindi name. */
export function rashifalHiLinkLabel(rashiName: string): string {
  return `आज का ${rashiName} राशिफल पढ़ें`;
}

/**
 * The check's form props, shared by the server-rendered shell
 * (RashifalHubCheckLazy), the island's BirthDetailsForm and
 * BirthToolFormShell.parity.test.tsx, so every frame before and after the
 * island loads reads the same words. The English check's card in Hindi: no
 * name field (the answer is the seeker's Moon sign) and no form heading (the
 * section's heading names the card; BirthDetailsForm keys its input ids on
 * the heading, "-default" without one). The birth time stays optional: the
 * date alone settles the sign on most days (lib/rashi-check.ts).
 */
export const RASHIFAL_CHECK_HI_FORM = {
  language: "hi",
  submitLabel: RASHIFAL_CHECK_HI_COPY.submit,
  collectName: false,
} as const;
